import { FC, useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import { saveAs } from "file-saver";
import moment from "moment";
import { toast } from "react-toastify";
import { AppContext } from "../../appContext/AppContext";
import { CODE } from "../../utils/Constant";
import TextField from "../../component/TextField";
import { downloadTemplateTonDauKy, importTonDauKy } from "../services/ThongKeServices";

interface Props {
  show: boolean;
  onHide: () => void;
  nhomVatTu: any;
  onImported?: () => void;
}

// Lỗi trả về dạng blob vì request yêu cầu responseType blob để nhận được file lỗi
const getErrorMessage = async (error: any) => {
  const defaultMessage = "Có lỗi xảy ra, vui lòng thử lại !";
  try {
    const text = await error?.response?.data?.text?.();
    return (text && JSON.parse(text)?.message) || defaultMessage;
  } catch {
    return defaultMessage;
  }
};

const DialogNhapTonDauKy: FC<Props> = ({ show, onHide, nhomVatTu, onImported }) => {
  const { setIsLoading } = useContext(AppContext);

  const handleDownloadTemplate = async () => {
    try {
      setIsLoading(true);
      const res = await downloadTemplateTonDauKy();
      if (CODE.SUCCESS === res.status) {
        saveAs(res.data, "Mẫu nhập tồn kho đầu kỳ.xlsx");
        toast.success("Lưu file mẫu thành công");
      }
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra, vui lòng thử lại !");
    } finally {
      setIsLoading(false);
    }
  };

  const handleImport = async (e: any) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!nhomVatTu?.id) return toast.warning("Vui lòng chọn nhóm vật tư");
    try {
      setIsLoading(true);
      const res = await importTonDauKy(file, nhomVatTu?.id);
      const contentType = res.headers["content-type"];
      if (contentType && !contentType.includes("application/json")) {
        saveAs(res.data, `Loi_nhap_ton_dau_ky_${moment().format("HHmm_DDMMYYYY")}.xlsx`);
        toast.warning("Đã nhập các dòng hợp lệ. Có dòng lỗi, vui lòng xem file tải về.");
        onImported?.();
        onHide();
        return;
      }
      const data = JSON.parse(await res.data.text());
      if (CODE.SUCCESS === data?.code) {
        toast.success("Nhập tồn kho đầu kỳ thành công");
        onImported?.();
        onHide();
      } else {
        toast.error(data?.message || "Có lỗi xảy ra, vui lòng thử lại !");
      }
    } catch (error: any) {
      console.error(error);
      toast.error(await getErrorMessage(error));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered animation className="background__modal dialog-background">
      <Modal.Header className="header-modal" closeButton>
        <Modal.Title className="text-white text-uppercase">Nhập tồn đầu kỳ</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <div className="d-flex justify-content-center gap-3">
          <Button className="btn-fill" onClick={handleDownloadTemplate}>
            Tải mẫu nhập tồn kho đầu kỳ
          </Button>
          <Button className="btn-fill position-relative">
            Nhập tồn kho đầu kỳ
            <TextField
              className="btn-file"
              type="file"
              name="fileNhapTonDauKy"
              onChange={(e: any) => handleImport(e)}
            />
          </Button>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end p-2 border-top">
        <Button className="btn-outline min-w-80px" onClick={onHide}>
          Đóng
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DialogNhapTonDauKy;
